module.exports = __webpack_public_path__ + "img/philosophy_machine.3c6847c9.webp";